import React from "react";
import { Button } from "antd";

export default function MessagePopup({ message, onClose, type = "error" }) {
  const getButtonColor = () => {
    switch (type) {
      case "error":
        return "#ff4d4f";
      case "success":
        return "#52c41a";
      case "warning":
        return "#faad14";
      default:
        return "#1890ff";
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
      }}
    >
      <span>{message}</span>
      <Button
        type="link"
        size="small"
        onClick={onClose}
        style={{
          padding: "0 8px",
          color: getButtonColor(),
          fontWeight: "500",
        }}
      >
        ปิด
      </Button>
    </div>
  );
}
